export default __webpack_public_path__ + "static/media/kone-car-designer-app-for-mobile-devices.707aff5c.jpg";